import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { Quotation, QuotationItem } from "../../../generated/graphql";
import moment from "moment";
import { Fragment } from "react/jsx-runtime";

const QuotationItems: React.FC<{ quotation: Quotation }> = ({ quotation }) => {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (((quotation?.quotationItems || []) as QuotationItem[]).length <= 0) {
    return <></>;
  }

  return (
    <View style={styles.container}>
      <View>
        {((quotation?.quotationItems || []) as QuotationItem[]).map(
          (item, indexItem) => {
            const lines = [
              {
                label: "Number Of People",
                value: `${item.numberOfPax} Pax`,
              },
              {
                label: "Price / PAX",
                value: formatter.format(item.pricePerPax),
              },
              {
                label: "Airline",
                value: item.airline,
              },
              {
                label: "Class",
                value: item.class,
              },
              {
                label: "Passenger Name",
                value: item.passengers,
              },
            ];

            return (
              <Fragment key={indexItem}>
                <View>
                  {lines.map((line, indexLine) => (
                    <View
                      key={indexLine}
                      style={[
                        styles.itemLine,
                        {
                          backgroundColor:
                            (indexLine + 1) % 2 === 0 ? "#fff" : "#f2f2f3",
                        },
                      ]}
                    >
                      <Text
                        style={[
                          styles.itemLineText,
                          {
                            width: 100,
                            fontWeight: 600,
                          },
                        ]}
                      >
                        {line.label}
                      </Text>
                      <Text style={[styles.itemLineText]}>:</Text>
                      {Array.isArray(line.value) ? (
                        <View>
                          {item.passengers.map((name, index) => (
                            <Text
                              key={`${indexLine}-${index}`}
                              style={styles.itemLineText}
                            >
                              {name}
                            </Text>
                          ))}
                        </View>
                      ) : (
                        <Text style={styles.itemLineText}>{line.value}</Text>
                      )}
                    </View>
                  ))}
                  <View style={styles.headerContainer}>
                    <View style={[styles.itemRow]}>
                      <Text
                        style={[
                          styles.itemCol,
                          styles.itemHeader,
                          { width: "30%" },
                        ]}
                      >
                        No. Flight
                      </Text>
                      <Text
                        style={[
                          styles.itemCol,
                          styles.itemHeader,
                          { width: "15%" },
                        ]}
                      >
                        Date
                      </Text>
                      <Text
                        style={[
                          styles.itemCol,
                          styles.itemHeader,
                          { width: "20%" },
                        ]}
                      >
                        Travel
                      </Text>
                      <Text
                        style={[
                          styles.itemCol,
                          styles.itemHeader,
                          { width: "17.5%" },
                        ]}
                      >
                        Depart Time
                      </Text>
                      <Text
                        style={[
                          styles.itemCol,
                          styles.itemHeader,
                          { width: "17.5%" },
                        ]}
                      >
                        Arrival Time
                      </Text>
                    </View>
                  </View>
                  {item.quotationItemFlights.map((flight, index) => {
                    return (
                      <View
                        style={[
                          styles.itemRow,
                          {
                            backgroundColor:
                              (index + 1) % 2 === 0 ? "#fff" : "#f2f2f3",
                          },
                        ]}
                        key={`${indexItem}-${index}`}
                      >
                        <Text style={[styles.itemCol, { width: "30%" }]}>
                          {flight.flightNumber}
                        </Text>
                        <Text style={[styles.itemCol, { width: "15%" }]}>
                          {moment(flight.departTime).format("DD MMM Y")}
                        </Text>
                        <Text style={[styles.itemCol, { width: "20%" }]}>
                          {flight.travel}
                        </Text>
                        <Text style={[styles.itemCol, { width: "17.5%" }]}>
                          {moment(flight.departTime).format("HH:mm A")}
                        </Text>
                        <Text style={[styles.itemCol, { width: "17.5%" }]}>
                          {moment(flight.arrivalTime).format("HH:mm A")}
                        </Text>
                      </View>
                    );
                  })}
                </View>
                <View style={styles.line} />
              </Fragment>
            );
          },
        )}
      </View>
    </View>
  );
};

// Create styles
const styles = StyleSheet.create({
  container: {
    marginBottom: 0,
    fontFamily: "Poppins",
    fontSize: 8,
  },
  headerContainer: {
    backgroundColor: "#192855",
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 4,
    paddingRight: 4,
  },
  itemRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 4,
    paddingRight: 4,
    gap: 5,
  },
  itemCol: {
    textAlign: "center",
  },
  itemHeader: {
    fontWeight: 600,
    fontSize: 9,
    textTransform: "uppercase",
    color: "#fff",
  },
  itemLine: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 4,
    paddingRight: 4,
  },
  itemLineText: {},
  line: {
    height: 1,
    backgroundColor: "#192855",
    marginTop: 6,
    marginBottom: 6,
  },
});

export default QuotationItems;
